import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StickyChatService {
  // 初始状态
  showStickyChatSource = new BehaviorSubject<any>(false);
  showChatLogSource = new BehaviorSubject<any>(false);
  // 获取状态
  showSticky = this.showStickyChatSource.asObservable();
  showLog = this.showChatLogSource.asObservable();

  // 传递的私信对象
  partnerPkgSource = new BehaviorSubject<any>(undefined);
  partnerPkg = this.partnerPkgSource.asObservable();

  constructor() { }

  // 更新状态
  updateState(state) {
    this.showStickyChatSource.next(state);
  }
  toggleChatLog(show) {
    this.showChatLogSource.next(show);
  }

  transmitPartner(obj) {
    this.partnerPkgSource.next(obj);
  }
}
